import React, { createRef, useRef } from 'react'
// import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// Components
import Phone1Image from '@/assets/images/feature-phone-mobile-1.png'
import Phone2Image from '@/assets/images/feature-phone-mobile-2.png'
import Phone3Image from '@/assets/images/feature-phone-mobile-3.png'
import Phone4Image from '@/assets/images/feature-phone-mobile-4.png'
import PhoneUrlImage from '@/assets/images/feature-url.png'
import NetWorkImage from '@/assets/images/feature-network.png'
import NetWorkMiddleImage from '@/assets/images/feature-network-mid.png'
import DistributionImage from '@/assets/images/feature-distribution.png'
import MediaImage from '@/assets/images/feature-media.png'
import AwardsImage from '@/assets/images/feature-awards.png'
import FeatureMobileItem from './components/FeatureMobileItem'

// Lib MISC
import featureData from '@/constants/featureData'
import { useFeatureMobileAnimation } from '@/computedValues/useFeatureMobileAnimation'
import { useFeatureImageWidth } from '@/computedValues/useFeatureImageWidth'

import styles from './style.scss'
import words from "@/assets/worddict.json"

const cx = classnames.bind(styles)

gsap.registerPlugin(ScrollTrigger)

export const propTypes = {}

function MobileContent ({ lang }) {
  const phoneImageRef = createRef(null) // 因為 useRef 會 keep initial ref，透過 createRef 確保會拿到新的 ref 的 width
  const phoneUrlRef = useRef(null)
  const netWorkRef = useRef(null)
  const distributionRef = useRef(null)
  const cardRef = useRef(null)

  const Feature = featureData(words[lang])

  useFeatureMobileAnimation()
  useFeatureImageWidth({ phoneImageRef, phoneUrlRef, netWorkRef, distributionRef, cardRef })

  return (
    <div className={cx('mobile-content')}>
      <div className={cx('mobile-content-wrapper')}>
        <div className={cx('mobile-content-wrapper-display', 'fixed')}>
          <div className={cx('mobile-content-wrapper-display-image', 'feature-mobile-item-1')}>
            <img className={cx('mobile-content-wrapper-display-image-item')} src={Phone1Image} />
          </div>
          <div className={cx('mobile-content-wrapper-display-image', 'feature-mobile-item-2')}>
            <img className={cx('mobile-content-wrapper-display-image-item')} ref={phoneImageRef} src={Phone2Image} />
            <img ref={phoneUrlRef} id='phone-url' src={PhoneUrlImage} />
          </div>
          <div className={cx('mobile-content-wrapper-display-image', 'feature-mobile-item-3')}>
            <img className={cx('mobile-content-wrapper-display-image-item')} src={Phone2Image} />
            <div ref={netWorkRef} id='phone-network'>
              <img id='phone-network-around' src={NetWorkImage} />
              <img id='phone-network-middle' src={NetWorkMiddleImage} />
            </div>
          </div>
          <div className={cx('mobile-content-wrapper-display-image', 'feature-mobile-item-4')}>
            <img className={cx('mobile-content-wrapper-display-image-item')} src={Phone3Image} />
            <div ref={distributionRef} id='phone-distribution'>
              <img id='phone-distribution-image' src={DistributionImage} />
            </div>
          </div>
          <div className={cx('mobile-content-wrapper-display-image', 'feature-mobile-item-5')}>
            <img className={cx('mobile-content-wrapper-display-image-item')} src={Phone4Image} />
            <div ref={cardRef} id='phone-card'>
              <img id='phone-card-media' src={MediaImage} />
              <img id='phone-card-awards' src={AwardsImage} />
            </div>
          </div>
        </div>
      </div>
      <div className={cx('mobile-content-list')}>
        {
          Feature.map((item, index) => (
            <FeatureMobileItem key={index} index={index} {...item} />
          ))
        }
      </div>
    </div>
  )
}

MobileContent.propTypes = propTypes

export default MobileContent
